import { Icon } from "@iconify/react";
import React, { useEffect, useState } from "react";

import PieChat from "../../../components/charts/rechart/PieChat";
import Mapchart from "../../../components/Map/Mapchart";
import { BarChartNoPadding } from "../../../components/charts/rechart/BarChartNoPadding";
import { fetchAdminDashboard } from "../../../../services/DashboardService";
import { getCurrentFormattedDate } from "../../../../utils/dateFormatter";
import Loader from "../../../components/Loader";
import { processObjToArrayInMonth } from "../../../../utils/allFormatter";
import LineChart1 from "../../../components/charts/Chartjs/LineChart1";
import { useTranslation } from "react-i18next";

const AdminDashboard = () => {
  const { t } = useTranslation();
  const [dasboardData, setDasboardData] = useState({});
  const [loading, setLoading] = useState(true);
  const [businessProgessByYear, setBusinessProgessByYear] = useState([]);
  const [businessProgressFilter, setBusinessProgressFilter] = useState("");
  useEffect(() => {
    getDasboardData();
  }, []);

  const getDasboardData = () => {
    const todayDate = getCurrentFormattedDate();

    fetchAdminDashboard({ from: "2024-01-01", to: todayDate })
      .then((res) => {
        const response = res?.data?.result;
        console.log(response);
        setDasboardData(response);

        const tempbusinessProgressData = processObjToArrayInMonth(
          response?.graphs?.businessesAddedOverTime
        );

        setBusinessProgressFilter(tempbusinessProgressData?.[0]?.year);
        setBusinessProgessByYear(tempbusinessProgressData);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const cardArray = [
    {
      icon: (
        <Icon
          icon="mdi:users"
          className="currency-icon p-1"
          fontSize={60}
          color="#EB8153"
        />
      ),
      value: dasboardData?.totalNumberOfRegisteredUsers,
      title: `${t("adminDashboardCard1")}`,
    },
    {
      icon: (
        <Icon
          icon="mdi:users"
          className="currency-icon p-1"
          fontSize={60}
          color="#EB8153"
        />
      ),
      value: dasboardData?.totalNumberOfBuyerProfiles,
      title: `${t("adminDashboardCard2")}`,
    },
    {
      icon: (
        <Icon
          icon="mdi:users"
          className="currency-icon p-1"
          fontSize={60}
          color="#EB8153"
        />
      ),
      value: dasboardData?.totalNumberOfSellerProfiles,
      title: `${t("adminDashboardCard3")}`,
    },
    {
      icon: (
        <Icon
          icon="bxs:report"
          className="currency-icon p-1"
          fontSize={60}
          color="#EB8153"
        />
      ),
      value: dasboardData?.totalNumberOfReports,
      title: `${t("adminDashboardCard4")}`,
    },
    {
      icon: (
        <Icon
          icon="octicon:graph-16"
          className="currency-icon p-1"
          fontSize={60}
          color="#EB8153"
        />
      ),
      value: dasboardData?.totalNumberOfRates,
      title: `${t("adminDashboardCard5")}`,
    },
    {
      icon: (
        <Icon
          icon="healthicons:money-bag-outline"
          className="currency-icon p-1"
          fontSize={60}
          color="#EB8153"
        />
      ),
      value: dasboardData?.totalPlatformRevenue,
      title: `${t("adminDashboardCard6")}`,
    },
    {
      icon: (
        <Icon
          icon="mdi:users"
          className="currency-icon p-1"
          fontSize={60}
          color="#EB8153"
        />
      ),
      value: dasboardData?.totalNumberOfProfessionalsProfiles,
      title: `${t("adminDashboardCard7")}`,
    },
    {
      icon: (
        <Icon
          icon="carbon:platforms"
          className="currency-icon p-1"
          fontSize={60}
          color="#EB8153"
        />
      ),
      value: dasboardData?.totalNumberOfBusinesses,
      title: `${t("adminDashboardCard8")}`,
    },
    {
      icon: (
        <Icon
          icon="ep:sell"
          className="currency-icon p-1"
          fontSize={60}
          color="#EB8153"
        />
      ),
      value: 5,
      title: `${t("adminDashboardCard9")}`,
    },
  ];
  const businessDisturbutionByIndustry =
    dasboardData?.graphs?.businessDisturbutionByIndustry?.map((item) => {
      return {
        name: item?.industry,
        count: item?.count,
      };
    });

  const filteredBusninessProgressData = businessProgessByYear?.filter(
    (item) => {
      const isYearMatch =
        !businessProgressFilter || item?.year === businessProgressFilter;
      return isYearMatch;
    }
  );

  return (
    <div>
      {loading && <Loader forProcess={true} />}
      <h2 className="mb-5">{t("adminDashboardTitle")}</h2>

      {/* cards */}

      <div className="row">
        {cardArray?.map((item, index) => (
          <div className="col-xl-4 col-md-4 col-sm-6 px-2" key={index}>
            <div className="card card-coin ">
              <div className="card-body text-center">
                {item?.icon}
                <h2 className="text-black mb-2 font-w600">
                  {item?.value ?? 0}
                </h2>
                <p className="mb-0 fs-14">
                  {/* <span className="text-success me-1">45%</span> */}
                  {item?.title}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Business Graph */}
      <div className="d-flex gap-5">
        <div className="card card-coin w-50 ps-5 pt-3">
          <h3>{t("adminDashboardBusiness")}</h3>
          <div className="mx-auto ">
            <PieChat
              data={[
                {
                  name: `${t("hsold")}`,
                  count:
                    dasboardData?.graphs?.businessesStatusGraph
                      ?.numberofbusinessessold,
                },
                {
                  name: `${t("havailable")}`,
                  count:
                    dasboardData?.graphs?.businessesStatusGraph
                      ?.numberofbusinessesavailable,
                },
                {
                  name: `${t("pending")}`,
                  count:
                    dasboardData?.graphs?.businessesStatusGraph
                      ?.numberofbusinessespending,
                },
              ]}
              colors={["#10439F", "#EB8153", "#B4B4B8"]}
              height={600}
            />
          </div>
        </div>
        <div className="card card-coin w-50 ps-5 pt-3">
          <h3>{t("adminDashboardBusinessesDistrubution")}</h3>
          <div className="mx-auto ">
            <PieChat
              data={businessDisturbutionByIndustry ?? []}
              colors={["#10439F", "#EB8153", "#B4B4B8", "#FEB941"]}
              height={600}
            />
          </div>
        </div>
      </div>

      <div className="card card-coin px-5">
        <div className="d-flex justify-content-between align-items-center my-3">
          <h3>{t("adminDashboardBusinessesProgress")}</h3>
          <select
            className=" form-control"
            style={{ width: "150px", border: "1px solid #EEEEEE" }}
            onChange={(e) => setBusinessProgressFilter(e.target.value)}
          >
            {businessProgessByYear?.map((item, index) => (
              <option key={index} value={item?.year}>
                {item?.year}
              </option>
            ))}
          </select>
        </div>
        <LineChart1 data={filteredBusninessProgressData?.[0]?.data} />
      </div>

      <div className="card card-coin px-5">
        <div className="d-flex justify-content-between align-items-center my-3">
          <h3>{t("adminDashboardBusinessesCountries")}</h3>
        </div>
        <Mapchart />
      </div>

      <div className="w-100 d-flex justify-content-between align-items-stretch align-self-stretch gap-5">
        <div
          className="card card-coin px-3"
          style={{ width: "40%", height: "450px" }}
        >
          <div className="d-flex justify-content-between align-items-center my-3">
            <h3>{t("adminDashboardRevenue")}</h3>
            <select
              className=" form-control"
              style={{ width: "150px", border: "1px solid #EEEEEE" }}
            >
              <option value="1">2024</option>
              <option value="1">2023</option>
              <option value="1">2022</option>
              <option value="1">2021</option>
            </select>
          </div>
          <LineChart1 height={200} />
        </div>
        <div
          className=" card card-coin px-3"
          style={{ width: "60%", height: "450px" }}
        >
          <div className="d-flex justify-content-between align-items-center my-3">
            <h3>{t("adminDashboardContracts")}</h3>
            <select
              className=" form-control"
              style={{ width: "150px", border: "1px solid #EEEEEE" }}
            >
              <option value="1">2024</option>
              <option value="1">2023</option>
              <option value="1">2022</option>
              <option value="1">2021</option>
            </select>
          </div>
          <BarChartNoPadding
            data={dasboardData?.graphs?.contractsGraph}
            height={350}
          />
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
